import DraggableRow from "@/Components/DraggableRow/DraggableRow";
import useCommon from "@/shared/hooks/useCommon";
import { reorder } from "@/shared/utils/helpers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const PaymentMethods = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const tCommon = useCommon();
  const { control } = useFormContext();

  return (
    <Controller
      name="paymentMethods"
      control={control}
      render={({ value: paymentMethods, onChange }) => (
        <DraggableRow
          label={t("paymentMethods")}
          hint={t("cards.dragToSort")}
          variant="card"
          droppableId="paymentMethodDroppableId"
          onDrageEnd={({ destination, source }) => {
            if (!destination) {
              return;
            }
            onChange(reorder(paymentMethods, source.index, destination.index));
          }}
          list={paymentMethods.map((item) => ({
            key: item.label,
            component: <div>{tCommon(item.label)}</div>,
          }))}
        />
      )}
    />
  );
};

export default PaymentMethods;
